/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Box, Typography, CircularProgress } from "@material-ui/core";

import Modal from "react-modal";

import { LazyLoadImage } from "react-lazy-load-image-component";
import LabelCheckerLabelling from "./LabelCheckerLabelling";
import { printLabel } from "../../containers/LabelSelector/LabelSelector";
import { getFetch, postData } from "../../utils/fetchUtils";
import {
  FullLabelType,
  TrasheventListType,
  LabellingModal,
  FilteredTrasheventResponse,
  PaginationState,
  QueryParamsType,
} from "./_types";

const AWS = require("aws-sdk");
const s3 = new AWS.S3({
  accessKeyId: "AKIA4ZN2FXCSXSLJ7BCQ",
  secretAccessKey: "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",
  useAccelerateEndpoint: false,
  signatureVersion: "v4",
  region: "eu-central-1",
});

const customModalStyles = {
  content: {
    width: "165vh",
    height: "92vh",
    left: "50%",
    top: "53%",
    transform: "translate(-50%, -50%)",
  },
  overlay: { zIndex: 1000 },
};

const LabelCheckerTrasheventList: React.FC<{
  queryParams: QueryParamsType;
}> = (props) => {
  const scrollableRef = useRef<HTMLDivElement>(null);

  const [trasheventList, setTrasheventList] = useState<{ [label: string]: TrasheventListType }>({}),
    [currDisplay, setCurrDisplay] = useState<{ [label: string]: boolean }>({}),
    [imageURLs, setImageURLs] = useState<{ [label: string]: string }>({}),
    [labellingModal, setLabellingModal] = useState<LabellingModal>({
      trasheventData: null,
      title: "",
      imageURL: null,
      prevImageURL: null,
      isOpen: false,
    }),
    [fullLabelData, setFullLabelData] = useState<{ [label: string]: FullLabelType }>(null),
    [pagination, setPagination] = useState<PaginationState>({
      hasMore: true,
      nextCursor: 0,
      isLoadingMore: false,
    });
  const [updatingDVCQ, setUpdatingDVCQ] = useState(false);

  useEffect(() => {
    setTrasheventList({});
    setCurrDisplay({});
    setImageURLs({});
    setPagination({
      hasMore: true,
      nextCursor: 0,
      isLoadingMore: false,
    });
    loadLabels();
    loadMoreTrashevents(true);
  }, [props.queryParams]);

  const getImageURL = (imageKey: string): string => {
    if (Object.prototype.hasOwnProperty.call(imageURLs, imageKey)) return imageURLs[imageKey];

    const imageUrl = getURL(imageKey);
    setImageURLs((prevImageUrl) => ({
      ...prevImageUrl,
      [imageKey]: imageUrl,
    }));

    return imageUrl;
  };

  const getURL = (imageKey: string): string =>
    s3.getSignedUrl("getObject", {
      Bucket: "kitroengine-s3",
      Key: imageKey,
      Expires: 21600,
    });

  const getDateString = (datetime: string): string => {
    const myDate = new Date(datetime);
    return myDate.toString().split("GMT")[0];
  };

  const switchImage = (id: number, status: boolean): void => {
    const currDisplayTemp = currDisplay;
    currDisplayTemp[id] = status;
    setCurrDisplay((prevDisplay) => ({
      ...prevDisplay,
      [id]: status,
    }));
  };

  const addOrRemoveFromCD = async (trashevent: TrasheventListType): Promise<void> => {
    if (updatingDVCQ) return;
    setUpdatingDVCQ(true);
    if (trashevent.on_cd) {
      // currently on CD, so remove
      await getFetch(`/save-dv-images?trashevent_id=${trashevent.trashevent_id}`, { method: "DELETE" });
    } else {
      // not on CD, so add
      const payload = {
        mode: "check images",
        tasks: [
          {
            id: trashevent.trashevent_id,
            trashevent_id: trashevent.trashevent_id,
            dv_type: "categories",
            status: "approved",
            edited: false,
            labels: trashevent.final_labels,
            errors: trashevent.final_errors,
          },
        ],
      };
      await postData("/save-dv-images", {
        data: payload,
        api: null,
        method: "POST",
      });
    }
    trashevent.on_cd = !trashevent.on_cd;
    setTrasheventList((prevList) => ({
      ...prevList,
      [trashevent.trashevent_id]: trashevent,
    }));
    setUpdatingDVCQ(false);
  };

  const generateTrasheventList = (): Array<JSX.Element> => {
    const trashevents = [];

    const isAvoidable = (id: number) => {
      if (fullLabelData) return id in fullLabelData ? fullLabelData[id].avoidable === "edible" : false;
      return true;
    };
    const labelName = (id: number) => {
      if (fullLabelData) return id in fullLabelData ? printLabel(fullLabelData[id]) : "inactive label";
      return "N/A";
    };

    for (const trashevent in trasheventList) {
      const finalLabels = [];
      const consensusLabels = [];
      const trasheventData = trasheventList[trashevent];

      for (const label in trasheventData.final_labels) {
        const labelTrashevent = trasheventData.final_labels[label];
        finalLabels.push(
          <div key={label} style={{ color: isAvoidable(labelTrashevent.id) ? "green" : "red" }}>
            {`${labelName(labelTrashevent.id)} - ${labelTrashevent.percentage}%`}
          </div>
        );
      }

      for (const label in trasheventData.consensus_labels) {
        const labelTrashevent = trasheventData.consensus_labels[label];
        consensusLabels.push(
          <div key={label} style={{ color: isAvoidable(labelTrashevent.id) ? "green" : "red" }}>
            {labelName(labelTrashevent.id) + " - " + labelTrashevent.username}
          </div>
        );
      }

      let consensusMsg = "Consensus Match";
      if (!trasheventData.consensus_matched) {
        consensusMsg = trasheventData.consensus_conflict
          ? "Consensus Conflict:" + trasheventData.cons_conflict_checked_by
          : "Directly Labelled by " + trasheventData.final_username;
      }

      const cdButtonStyling = {
        border: 0,
        backgroundColor: trasheventData.on_cd ? "red" : "green",
        color: "white",
      };

      trashevents.push(
        <div
          key={trashevent}
          onClick={() => toggleLabellingModal(true, trasheventData)}
          className={"labelCheckerTrasheventItem"}
        >
          <div style={{ position: "relative" }}>
            <div
              className={"imageOverlay"}
              onMouseOver={() => switchImage(trasheventData.trashevent_id, true)}
              onMouseLeave={() => switchImage(trasheventData.trashevent_id, false)}
            >
              {currDisplay[trasheventData.trashevent_id] ? "Prev" : "Curr"}
            </div>
            <LazyLoadImage
              id="0"
              src={
                currDisplay[trasheventData.trashevent_id]
                  ? getImageURL(trasheventData.prev_image_id)
                  : getImageURL(trasheventData.image_id)
              }
              key={trasheventData.trashevent_id}
              className="labelCheckerImageContainer photo"
            />
          </div>
          <div
            className="labelCheckerImageInformation"
            onClick={() => toggleLabellingModal(true, trasheventData, false)}
          >
            <h3>{getDateString(trasheventData.datetime)}</h3>
            <div>{`Device ID: ${trasheventData.device_id} - Weight: ${trasheventData.weight}g`}</div>
            <div>{finalLabels}</div>
            <h3
              style={{
                display: "block",
                marginBottom: "0px",
                fontSize: "16px",
              }}
            >
              {consensusMsg}
            </h3>
            <div>{trasheventData.consensus_conflict ? consensusLabels : ""}</div>
            <div>Event ID: {trasheventData.trashevent_id}</div>
            {trasheventData.viable_for_cd && (
              <button
                disabled={updatingDVCQ}
                style={cdButtonStyling}
                onClick={(event) => {
                  addOrRemoveFromCD(trasheventData);
                  event.stopPropagation();
                }}
              >
                {trasheventData.on_cd ? "Remove from CD" : "Approve for CD"}
              </button>
            )}
          </div>
        </div>
      );
    }

    return trashevents;
  };

  const toggleLabellingModal = (
    status: boolean,
    data: TrasheventListType | null,
    saved: boolean = false,
    add_to_exam: boolean = false
  ): void => {
    if (status) {
      setLabellingModal({
        trasheventData: data,
        title: getDateString(data.datetime),
        imageURL: getImageURL(data.image_id),
        prevImageURL: getImageURL(data.prev_image_id),
        isOpen: true,
      });
    } else {
      if (saved) relabelTrashevent(data, add_to_exam);

      setLabellingModal({
        trasheventData: null,
        title: "",
        imageURL: null,
        prevImageURL: null,
        isOpen: false,
      });
    }
  };

  const relabelTrashevent = (trasheventData: TrasheventListType, add_to_exam: boolean): void => {
    getFetch("/relabel-trashevent", { method: "POST", data: { trasheventData: trasheventData } })
      .then(() => {
        if (add_to_exam) {
          postData("/training/exam/question", {
            data: { trashevent_id: trasheventData.trashevent_id },
            api: null,
            method: "POST",
          }).catch(() => {
            alert("Error adding trashevent to exam.");
          });
        }
      })
      .catch(() => {
        alert("Error relabelling trashevent.");
      });

    setTrasheventList((prevList) => ({
      ...prevList,
      [trasheventData.trashevent_id]: trasheventData,
    }));
  };

  const loadLabels = (): void => {
    getFetch("/get-labels?active=true", {}).then((data) => {
      setFullLabelData(data.allLabels);
    });
  };

  const loadMoreTrashevents = useCallback(
    (init: boolean = false): void => {
      if (
        !init &&
        (!pagination.hasMore || pagination.isLoadingMore || (!pagination.nextCursor && pagination.nextCursor !== 0))
      )
        return;

      setPagination((prev) => ({
        ...prev,
        isLoadingMore: true,
      }));

      const postData = {
        ...props.queryParams,
        ...(!init && { cursor: pagination.nextCursor }),
      };

      getFetch("/get-filtered-trashevents", { data: postData, method: "POST" })
        .then((data: FilteredTrasheventResponse) => {
          setTrasheventList((prev) => ({
            ...prev,
            ...data.trashevents,
          }));

          const newDisplay = {};
          for (const trashevent in data.trashevents) newDisplay[trashevent] = false;
          setCurrDisplay((prev) => ({
            ...prev,
            ...newDisplay,
          }));

          setPagination((prev) => ({
            ...prev,
            hasMore: data.has_more,
            nextCursor: data.next_cursor,
            isLoadingMore: false,
          }));
        })
        .catch((_) => {
          setPagination((prev) => ({
            ...prev,
            isLoadingMore: false,
          }));
        });
    },
    [pagination.hasMore, pagination.isLoadingMore, pagination.nextCursor, props.queryParams]
  );

  // Handle continuous scroll and fetch of more trashevents
  useEffect(() => {
    const handleScroll = (): void => {
      if (!scrollableRef.current) return;

      const BOTTOM_PX_LOAD_MORE_THRESHOLD = 100;
      const { scrollTop, scrollHeight, clientHeight } = scrollableRef.current;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - BOTTOM_PX_LOAD_MORE_THRESHOLD;

      if (isNearBottom && pagination.hasMore && !pagination.isLoadingMore) loadMoreTrashevents();
    };

    const scrollableDiv = scrollableRef.current;
    if (scrollableDiv) {
      scrollableDiv.addEventListener("scroll", handleScroll);
      return () => {
        scrollableDiv.removeEventListener("scroll", handleScroll);
      };
    }
  }, [pagination.hasMore, pagination.isLoadingMore, pagination.nextCursor, loadMoreTrashevents]);

  const saveImageChanges = (labelSelection: TrasheventListType["final_labels"], errors: Array<number>): void => {
    const newTrasheventData = {
      ...labellingModal.trasheventData,
      final_labels: labelSelection,
      final_errors: errors,
    };

    setLabellingModal((prevLabellingModal) => ({
      ...prevLabellingModal,
      trasheventData: {
        ...prevLabellingModal.trasheventData,
        final_labels: labelSelection,
        final_errors: errors,
      },
    }));

    toggleLabellingModal(false, newTrasheventData, true);
  };

  const addAndSaveImageChanges = (labelSelection: TrasheventListType["final_labels"], errors: Array<number>): void => {
    const newTrasheventData = {
      ...labellingModal.trasheventData,
      final_labels: labelSelection,
      final_errors: errors,
    };

    setLabellingModal((prevLabellingModal) => ({
      ...prevLabellingModal,
      trasheventData: {
        ...prevLabellingModal.trasheventData,
        final_labels: labelSelection,
        final_errors: errors,
      },
    }));

    toggleLabellingModal(false, newTrasheventData, true, true);
  };

  return (
    <>
      {!pagination.hasMore && Object.keys(trasheventList).length === 0 && (
        <Box
          sx={{
            textAlign: "center",
            p: 2,
            display: "block",
            width: "100%",
          }}
        >
          <Typography>No trashevents found matching the filter criteria.</Typography>
        </Box>
      )}

      <Modal
        isOpen={labellingModal.isOpen}
        onRequestClose={() => toggleLabellingModal(false, null, false)}
        contentLabel="LabellingModal"
        style={customModalStyles}
      >
        <LabelCheckerLabelling
          trasheventData={labellingModal.trasheventData}
          imageURL={labellingModal.imageURL}
          prevImageURL={labellingModal.prevImageURL}
          title={labellingModal.title}
          labelData={fullLabelData}
          saveImageChanges={saveImageChanges}
          addAndSaveImageChanges={addAndSaveImageChanges}
          addOrRemoveFromCD={addOrRemoveFromCD}
          labellingEnabled={true}
          requestClose={() => toggleLabellingModal(false, null, false)}
        />
      </Modal>
      <div ref={scrollableRef} className={"labelCheckerTrasheventList"}>
        {generateTrasheventList()}
        {pagination.isLoadingMore && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              py: 2,
            }}
          >
            <CircularProgress size={32} thickness={4} />
          </Box>
        )}
        {!pagination.hasMore && Object.keys(trasheventList).length > 0 && (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              padding: "16px",
            }}
          >
            <Typography>No more trashevents to load</Typography>
          </Box>
        )}
      </div>
    </>
  );
};

export default LabelCheckerTrasheventList;
